import { gql } from '@apollo/client';

// Query to get all notifications for a user
export const NOTIFICATIONS_LIST = gql`
  query NOTIFICATIONS_LIST($filter: NotificationFilter, $orderBy: [NotificationOrderBy]) {
    notificationsList(filter: $filter, orderBy: $orderBy, first: 50) {
      items {
        id
        title
        description
        status
        mode
        relatedEntityUrl
        jsonRecord
        createdAt
        updatedAt
        clearedAt
        deletedAt
        userId {
          id
        }
        templateId {
          id
          name
          isActive
        }
      }
      count
    }
  }
`;

// Query to get a single notification by ID
export const NOTIFICATION_GET = gql`
  query NOTIFICATION_GET($id: ID!) {
    notification(filter: { id: $id }) {
      id
      title
      description
      status
      mode
      relatedEntityUrl
      jsonRecord
      createdAt
      updatedAt
      clearedAt
      deletedAt
      userId {
        id
      }
      templateId {
        id
        name
        isActive
      }
    }
  }
`;

// Mutation to create a new notification with enhanced backend system
export const NOTIFICATION_CREATE = gql`
  mutation NOTIFICATION_CREATE($data: CreateNotificationInput!) {
    createNotification(data: $data) {
      success
      notificationId
      errors
    }
  }
`;

// Old mutation - commented out for reference
// export const NOTIFICATION_CREATE_OLD = gql`
//   mutation NOTIFICATION_CREATE_OLD($data: NotificationCreateInput!) {
//     notificationCreate(data: $data) {
//       id
//       title
//       description
//       status
//       mode
//       relatedEntityUrl
//       createdAt
//       userId {
//         id
//       }
//       templateId {
//         id
//         name
//         isActive
//       }
//     }
//   }
// `;

// Mutation to update notification status
export const NOTIFICATION_UPDATE_STATUS = gql`
  mutation NOTIFICATION_UPDATE_STATUS($id: ID!, $status: String!, $clearedAt: DateTime) {
    notificationUpdate(filter: { id: $id }, data: { 
      status: $status,
      clearedAt: $clearedAt
    }) {
      id
      status
      updatedAt
      clearedAt
    }
  }
`;

// Mutation to clear a notification
export const NOTIFICATION_CLEAR = gql`
  mutation NOTIFICATION_CLEAR($id: ID!, $clearedAt: DateTime!) {
    notificationUpdate(filter: { id: $id }, data: { 
      status: CLEARED,
      clearedAt: $clearedAt
    }) {
      id
      status
      clearedAt
      updatedAt
    }
  }
`;

// Query to get notification templates
export const NOTIFICATION_TEMPLATES_LIST = gql`
  query NOTIFICATION_TEMPLATES_LIST {
    notificationTemplatesList(filter: { isActive: { equals: true } }) {
      items {
        id
        name
        titleTemplate
        descriptionTemplate
        isActive
        createdAt
        updatedAt
      }
    }
  }
`;

// Subscription for real-time notification updates using 8base's built-in subscription
export const NOTIFICATION_SUBSCRIPTION = gql`
  subscription NOTIFICATION_SUBSCRIPTION($filter: NotificationSubscriptionFilter) {
    Notification(filter: $filter) {
      mutation
      node {
        id
        title
        description
        status
        mode
        relatedEntityUrl
        jsonRecord
        createdAt
        userId {
          id
        }
        templateId {
          id
          name
          isActive
        }
      }
    }
  }
`;

// Query to get unread notification count
export const UNREAD_NOTIFICATIONS_COUNT = gql`
  query UNREAD_NOTIFICATIONS_COUNT($filter: NotificationFilter) {
    notificationsList(filter: $filter) {
      count
    }
  }
`;

// Optimized query to get notifications grouped by status with counts
export const NOTIFICATIONS_GROUPED_BY_STATUS = gql`
  query NOTIFICATIONS_GROUPED_BY_STATUS($userId: ID!) {
    unread: notificationsList(filter: { 
      userId: { id: { equals: $userId } }, 
      status: { equals: "UNREAD" } 
    }, orderBy: ["createdAt_DESC"], first: 50) {
      items {
        id
        title
        description
        status
        mode
        relatedEntityUrl
        jsonRecord
        createdAt
        updatedAt
        clearedAt
        deletedAt
        userId {
          id
        }
        templateId {
          id
          name
          isActive
        }
      }
      count
    }
    read: notificationsList(filter: { 
      userId: { id: { equals: $userId } }, 
      status: { equals: "READ" } 
    }, orderBy: ["createdAt_DESC"], first: 50) {
      items {
        id
        title
        description
        status
        mode
        relatedEntityUrl
        jsonRecord
        createdAt
        updatedAt
        clearedAt
        deletedAt
        userId {
          id
        }
        templateId {
          id
          name
          isActive
        }
      }
      count
    }
    cleared: notificationsList(filter: { 
      userId: { id: { equals: $userId } }, 
      status: { equals: "CLEARED" } 
    }, orderBy: ["createdAt_DESC"], first: 50) {
      items {
        id
        title
        description
        status
        mode
        relatedEntityUrl
        jsonRecord
        createdAt
        updatedAt
        clearedAt
        deletedAt
        userId {
          id
        }
        templateId {
          id
          name
          isActive
        }
      }
      count
    }
  }
`;
